<template>
    <div class="content_class">
      <a-tabs default-active-key="1" @change="tabChangeHandle">
        <a-tab-pane key="1" tab="原料">
          <a-table
            :columns="materialColumns"
            :data-source="materialList"
            :pagination="materialPagination"
          >
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="营养分析">
          <a-table
            :columns="nutritionColumns"
            :data-source="nutritionList"
            :pagination="nutritionPagination"
          >
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
</template>

<script>
const materialColumns = [
  {
    title: '原料名称',
    dataIndex: 'one'
  },
  {
    title: '代码',
    dataIndex: 'oneNum',
  },
  {
    title: '百分比(%)',
    dataIndex: 'one2',
  },
  {
    title: '用量',
    dataIndex: 'one3',
  },
  {
    title: '单位',
    dataIndex: 'one4',
  },
  {
    title: '最大值',
    dataIndex: 'one5',
  },
  {
    title: '最小值',
    dataIndex: 'one6',
  },
];
const nutritionColumns = [
  {
    title: '指标名称',
    dataIndex: 'one'
  },
  {
    title: '指标全称',
    dataIndex: 'oneNum',
  },
  {
    title: '指标代码',
    dataIndex: 'one2',
  },
  {
    title: '数值',
    dataIndex: 'one3',
  },
  {
    title: '单位',
    dataIndex: 'one4',
  },
  {
    title: '最大值',
    dataIndex: 'one5',
  },
  {
    title: '最小值',
    dataIndex: 'one6',
  },
];
export default {
  data () {
    return {
      materialList: [{},{},{}],
      nutritionList: [{},{},{}],
      materialPagination: {
        total: 50,
        pageSize: 20,
        pageSizeOptions: ['10','20','30','40','50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onShowSizeChange(current, size){console.log(current, size)},
        onChange(page, pageSize){console.log(page, pageSize)},
      },
      nutritionPagination: {
        total: 50,
        pageSize: 20,
        pageSizeOptions: ['10','20','30','40','50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onShowSizeChange(current, size){console.log(current, size)},
        onChange(page, pageSize){console.log(page, pageSize)},
      },
      materialColumns,
      nutritionColumns

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .content_class {
    background-color: #fff;
    padding: 12px 16px;
    border-radius: 5px;
    .content_btn_class {
      margin-bottom: 10px;
      .add_class {
        margin-right: 10px;
      }
      .edit_class {
        margin-right: 10px;
      }
    }
  }
</style>